import { type CSSProperties } from 'react'

import '@fontsource/lato/400.css'
import '@fontsource/lato/700.css'

import { type TypographyVariantsOptions } from '@mui/material/styles'

import { type ExtraTypographyProps as OmsExtraTypographyProps } from '@oxfordmedicalsimulation/oms-fe-components'

import { colors } from './colors'

export interface ExtraTypographyProps extends OmsExtraTypographyProps {
  // Extra & custom typography styles go here
  link1: CSSProperties
  link2: CSSProperties
}

type ExtendedTypographyOptions = TypographyVariantsOptions & ExtraTypographyProps

export const typography: ExtendedTypographyOptions = {
  fontFamily: ['Lato', 'sans-serif'].join(','),
  body1: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: 0,
  },
  h1: {
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '22px',
    letterSpacing: '0.15px',
    color: colors.greyText,
  },
  h2: {
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '20px',
    color: colors.greyText,
  },
  h3: {
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '18px',
    color: colors.greyText,
  },
  button: {
    fontSize: '19px',
    fontWeight: 700,
    lineHeight: '27px',
    textTransform: 'initial',
  },
  caption: {
    fontSize: '14px',
    fontWeight: 600,
  },

  // Link typography colours are defined as part of the theme object, typography is MuiTypography-root
  link1: {},
  link2: {},

  // Typography styles required by the components library - will be deprecated and removed in a future update
  tooltip: {},
  small: {},
  tiny: {},
  caption1: {},
  dataGridLink: {},
  componentTooltip: {},
}
